import { type ReactNode } from 'react'
import {
  ClickableTable,
  ClickableTableBody,
  ClickableTableHead,
  ClickableTableHeader,
} from '@/components/Table/ClickableTable'
import type { TableSortOrder } from '@/components/Table'
import { JobsListEmpty } from '@/features/jobs/components/JobsListEmpty'
import { type ColumnId } from '@/features/jobs/list/jobs-table-columns'
import styles from './FirmDashboardJobsTable.module.css'

const jobTableColumnStyles: Partial<Record<ColumnId, string>> = {
  jobTitle: styles.primaryColumn,
  status: styles.statusColumn,
  clientTeam: styles.teamColumn,
}

export interface FirmDashboardJobsTableColumn {
  id: ColumnId
  header: string
  canSort?: boolean
  sortOrder: TableSortOrder
  onSort: (sortOrder: TableSortOrder) => void
}

export interface FirmDashboardJobsTableProps {
  showEmptyView: boolean
  columns: FirmDashboardJobsTableColumn[]
  children: ReactNode
  scrollLoader: ReactNode
  onClearSearchFilter: () => void
  corporateMode: boolean
}

export function FirmDashboardJobsTable({
  showEmptyView,
  columns,
  children,
  scrollLoader,
  onClearSearchFilter,
  corporateMode,
}: FirmDashboardJobsTableProps) {
  return (
    <div>
      {!showEmptyView ? (
        <>
          <ClickableTable striped stickyHeader className={styles.jobsTable}>
            <ClickableTableHead className={styles.tableHead}>
              {columns.map((col) => (
                <ClickableTableHeader
                  key={col.id}
                  canSort={col.canSort}
                  sortOrder={col.sortOrder}
                  onSort={col.onSort}
                  className={jobTableColumnStyles[col.id]}
                >
                  {col.header}
                </ClickableTableHeader>
              ))}
            </ClickableTableHead>
            <ClickableTableBody>{children}</ClickableTableBody>
          </ClickableTable>
          {scrollLoader}
        </>
      ) : (
        <div>
          <JobsListEmpty
            onClearSearchFilter={onClearSearchFilter}
            corporateMode={corporateMode}
          />
        </div>
      )}
    </div>
  )
}
